import React from 'react';

// An/Aus-Schalter der Admin-Reiter (aus AiTab.js herausgelöst, #574: auch in
// den Voicemail-Einstellungen).
const Schalter = ({ an, onChange, t, disabled = false }) => (
  <label className="status-toggle ai-schalter">
    <input type="checkbox" checked={an} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
    <span className={`toggle-slider ${an ? 'enabled' : 'disabled'}`}></span>
    <span className="status-text">{an ? t('common.active', 'Aktiv') : t('common.inactive', 'Inaktiv')}</span>
  </label>
);

export default Schalter;
